/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ActingReportByDriverQueryResponse,
  GetActingReportByDriverParams,
  GetActingReportByDriverXlsxParams
} from '../../model';

import { instance } from '../../index';
import type { ErrorType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getActingReportByDriver = (
    params: GetActingReportByDriverParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<ActingReportByDriverQueryResponse>(
      {url: `/api/v1/actings/reports/by-driver`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetActingReportByDriverQueryKey = (params: GetActingReportByDriverParams,) => {
    return [`/api/v1/actings/reports/by-driver`, ...(params ? [params]: [])] as const;
    }

    
export const getGetActingReportByDriverInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriver>>, GetActingReportByDriverParams['page']>, TError = ErrorType<unknown>>(params: GetActingReportByDriverParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingReportByDriverQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']> = ({ signal, pageParam }) => getActingReportByDriver({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingReportByDriverInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActingReportByDriver>>>
export type GetActingReportByDriverInfiniteQueryError = ErrorType<unknown>


export function useGetActingReportByDriverInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriver>>, GetActingReportByDriverParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriver>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriver>>, GetActingReportByDriverParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriver>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriver>>, GetActingReportByDriverParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingReportByDriverInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriver>>, GetActingReportByDriverParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriver>>, QueryKey, GetActingReportByDriverParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingReportByDriverInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingReportByDriverQueryOptions = <TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(params: GetActingReportByDriverParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingReportByDriverQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingReportByDriver>>> = ({ signal }) => getActingReportByDriver(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingReportByDriverQueryResult = NonNullable<Awaited<ReturnType<typeof getActingReportByDriver>>>
export type GetActingReportByDriverQueryError = ErrorType<unknown>


export function useGetActingReportByDriver<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriver>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriver>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriver<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriver>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriver>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriver<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingReportByDriver<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingReportByDriverQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingReportByDriverSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(params: GetActingReportByDriverParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingReportByDriverQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingReportByDriver>>> = ({ signal }) => getActingReportByDriver(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingReportByDriverSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActingReportByDriver>>>
export type GetActingReportByDriverSuspenseQueryError = ErrorType<unknown>


export function useGetActingReportByDriverSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingReportByDriverSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriver>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriver>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingReportByDriverSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActingReportByDriverXlsx = (
    params: GetActingReportByDriverXlsxParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<Blob>(
      {url: `/api/v1/actings/reports/by-driver/xlsx`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetActingReportByDriverXlsxQueryKey = (params: GetActingReportByDriverXlsxParams,) => {
    return [`/api/v1/actings/reports/by-driver/xlsx`, ...(params ? [params]: [])] as const;
    }

    
export const getGetActingReportByDriverXlsxInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, GetActingReportByDriverXlsxParams['page']>, TError = ErrorType<unknown>>(params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingReportByDriverXlsxQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']> = ({ signal, pageParam }) => getActingReportByDriverXlsx({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingReportByDriverXlsxInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>>
export type GetActingReportByDriverXlsxInfiniteQueryError = ErrorType<unknown>


export function useGetActingReportByDriverXlsxInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, GetActingReportByDriverXlsxParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverXlsxInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, GetActingReportByDriverXlsxParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverXlsxInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, GetActingReportByDriverXlsxParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingReportByDriverXlsxInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, GetActingReportByDriverXlsxParams['page']>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData, Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, QueryKey, GetActingReportByDriverXlsxParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingReportByDriverXlsxInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingReportByDriverXlsxQueryOptions = <TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingReportByDriverXlsxQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>> = ({ signal }) => getActingReportByDriverXlsx(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingReportByDriverXlsxQueryResult = NonNullable<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>>
export type GetActingReportByDriverXlsxQueryError = ErrorType<unknown>


export function useGetActingReportByDriverXlsx<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverXlsx<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>,
          TError,
          Awaited<ReturnType<typeof getActingReportByDriverXlsx>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverXlsx<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingReportByDriverXlsx<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingReportByDriverXlsxQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetActingReportByDriverXlsxSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActingReportByDriverXlsxQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>> = ({ signal }) => getActingReportByDriverXlsx(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActingReportByDriverXlsxSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>>
export type GetActingReportByDriverXlsxSuspenseQueryError = ErrorType<unknown>


export function useGetActingReportByDriverXlsxSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverXlsxSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActingReportByDriverXlsxSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActingReportByDriverXlsxSuspense<TData = Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError = ErrorType<unknown>>(
 params: GetActingReportByDriverXlsxParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActingReportByDriverXlsx>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActingReportByDriverXlsxSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



